import { connect } from 'react-redux';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import CommonDialog from '../shared/dialog/CommonDialog';
import * as UnlockActions from '../../actions/unlock';
import UnlockViewContainer from './UnlockViewContainer';

import css from './unlock-dialog.module.scss';

// exported for testing
export const styles = {
  content: {
    maxWidth: '100%',
    minWidth: 320,
  },
  body: {
    padding: 30,
  },
  title: {
    border: null,
    textAlign: 'center',
  },
  innerContent: {
    padding: 30,
  },
};

class UnlockDialog extends Component {
  static propTypes = {
    unlockActions: PropTypes.shape({
      unlockClosed: PropTypes.func.isRequired,
    }),
    unlockDialogOpen: PropTypes.bool,
    campaignId: PropTypes.number,
    campaignKey: PropTypes.string,
    unlockToken: PropTypes.string,
    viewType: PropTypes.string,
    unlockDialogWidth: PropTypes.number,
    unlockDialogHeight: PropTypes.number,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.unlockDialogHeight !== this.props.unlockDialogHeight) {
      // crappy workaround for material-ui bug.  Fixed in versions 1.x.x and beyond.
      // discussed at length here: https://github.com/callemall/material-ui/issues/1676
      setTimeout(() => {
        global.dispatchEvent(new Event('resize'));
      }, 250);
    }
  }

  handleClose = () => {
    this.props.unlockActions.unlockClosed();
  };

  render() {
    const {
      unlockActions,
      campaignId,
      campaignKey,
      unlockToken,
      viewType,
      unlockDialogOpen,
      unlockDialogWidth,
      unlockDialogHeight,
    } = this.props;

    const dynamicStyles = {
      content: {},
    };

    if (unlockDialogWidth) {
      dynamicStyles.content.width = unlockDialogWidth + 60;
    }

    if (unlockDialogHeight) {
      dynamicStyles.content.height = unlockDialogHeight + 60;
    }

    return (
      <CommonDialog
        key="unlockDialog"
        modal={false}
        dialogOpen={unlockDialogOpen}
        handleDialogClose={this.handleClose}
        overlayClassName="unlockDialogOverlay"
        contentStyle={{ ...styles.content, ...dynamicStyles.content }}
        contentClassName={css.unlockDialogContent}
        bodyClassName={css.unlockDialogBody}
        bodyStyle={styles.body}
        titleStyle={styles.title}
        autoScrollBodyContent={false}
        autoDetectWindowHeight={false}
      >
        <div style={styles.innerContent} className="innerContent">
          <UnlockViewContainer
            key="unlockViewContainer"
            unlockActions={unlockActions}
            campaignId={campaignId}
            campaignKey={campaignKey}
            unlockToken={unlockToken}
            viewType={viewType}
            isDialog
          />
        </div>
      </CommonDialog>
    );
  }
}

function mapStateToProps(state) {
  const {
    unlockDialogOpen,
    campaignId,
    campaignKey,
    unlockToken,
    viewType,
    unlockDialogWidth,
    unlockDialogHeight,
  } = state.unlockDetails;

  return {
    unlockDialogOpen,
    campaignId,
    campaignKey,
    unlockToken,
    viewType,
    unlockDialogWidth,
    unlockDialogHeight,
  };
}

function mapDispatchToProps(dispatch) {
  const actions = UnlockActions;

  return {
    unlockActions: bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UnlockDialog);
